import React from "react";
import { DialogTitle, DialogContent, Typography, Box } from "@mui/material";
import { DialogShell } from "@/shared/ui/DialogShell";
import type { Template } from "./types";

interface TemplatePreviewDialogProps {
  template: Template | null;
  onClose: () => void;
}

const TemplatePreviewDialog: React.FC<TemplatePreviewDialogProps> = ({
  template,
  onClose,
}) => {
  return (
    <DialogShell
      open={!!template}
      onClose={onClose}
      size="md"
      paperSx={{ borderRadius: 3, height: "70vh" }}
      titleId="template-preview-dialog-title"
    >
      <DialogTitle id="template-preview-dialog-title" sx={{ pb: 1, pr: 6 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {template?.name ?? "Template Preview"}
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box
          sx={{
            p: 3,
            fontFamily: "monospace",
            fontSize: "0.85rem",
            whiteSpace: "pre-wrap",
            color: "text.primary",
            overflowY: "auto",
            height: "100%",
          }}
        >
          {template?.content ?? "No content available."}
        </Box>
      </DialogContent>
    </DialogShell>
  );
};

export default TemplatePreviewDialog;
